import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box, Form, FormField, Heading, TextInput, Text } from 'grommet';

import { EMAIL_REGEXP } from 'src/utils/string.utils';
import { accountsPassword } from 'src/utils/account';
import { setToken } from 'src/reducers/user/userReducer';
import ButtonSpinner from 'src/components/ButtonSpinner';
import { FormExtendedEvent } from 'grommet/components/Form';

const messages = {
  invalid: 'Field is invalid',
  required: 'Field is required',
};

interface Form {
  email: string;
  password: string;
}

function LoginForm(): JSX.Element {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string>();
  const dispatch = useDispatch();

  const handleOnSubmit = useCallback(
    async (event: FormExtendedEvent<Form>) => {
      setIsLoading(true);
      try {
        const loginData = await accountsPassword.login({
          user: {
            email: event.value.email,
          },
          password: event.value.password,
        });

        dispatch(setToken(loginData.tokens.accessToken));
      } catch (err) {
        setError(String(err));
      }
      setIsLoading(false);
    },
    [dispatch]
  );

  const handleOnChange = useCallback(() => {
    setError(undefined);
  }, []);

  return (
    <Form onSubmit={handleOnSubmit} onValidate={handleOnChange} messages={messages} onChange={handleOnChange}>
      <Box direction='row' justify='center' margin={{ bottom: 'small' }}>
        <Heading level={3} margin='none'>
          Login
        </Heading>
      </Box>
      <FormField
        name='email'
        htmlFor='email'
        label='Email'
        validate={[{ regexp: EMAIL_REGEXP, message: 'Email is not valid' }]}
        required
      >
        <TextInput id='email' name='email' type='email' placeholder='Type your email' autoComplete='username' />
      </FormField>
      <FormField name='password' htmlFor='current-password' label='Password' required>
        <TextInput
          id='current-password'
          name='password'
          type='password'
          placeholder='Type your password'
          autoComplete='current-password'
        />
      </FormField>
      {error && (
        <Box pad={{ horizontal: 'small' }}>
          <Text color='status-error'>{error}</Text>
        </Box>
      )}
      <Box direction='row' margin={{ top: 'medium' }}>
        <ButtonSpinner type='submit' primary label='Login' isLoading={isLoading} />
      </Box>
    </Form>
  );
}

export default LoginForm;
